import type { Locale } from '../config'

export const LOCALE_STORAGE_KEY = 'browserkit.locale'

export function detectPreferredLocale(languages: readonly string[], storedLocale?: string | null): Locale {
  if (storedLocale === 'en' || storedLocale === 'zh-CN' || storedLocale === 'zh-TW' || storedLocale === 'es' || storedLocale === 'de' || storedLocale === 'ja' || storedLocale === 'fr' || storedLocale === 'pt-BR') return storedLocale

  for (const language of languages) {
    const normalized = language.toLowerCase()
    if (normalized.startsWith('zh-tw') || normalized.startsWith('zh-hk') || normalized.startsWith('zh-mo') || normalized.includes('hant')) return 'zh-TW'
    if (normalized.startsWith('zh')) return 'zh-CN'
    if (normalized.startsWith('es')) return 'es'
    if (normalized.startsWith('de')) return 'de'
    if (normalized.startsWith('ja')) return 'ja'
    if (normalized.startsWith('fr')) return 'fr'
    if (normalized.startsWith('pt')) return 'pt-BR'
    if (normalized.startsWith('en')) return 'en'
  }

  return 'en'
}
